/**
 * -------------------------------------------------------------------------------------------------
 * NOTE BOUTIQUE SKEEPERS
 * -------------------------------------------------------------------------------------------------
 *
 * Remplace la note et le nombre d'avis de la barre de confiance par les valeurs réelles de
 * Skeepers, lues sur le même fichier de statistiques que celui qu'interrogent leurs widgets :
 *
 *   https://cl-pbr.cxr.skeepers.io/<instance>/stats.json
 *      -> { ratingMean: 4.7117, currentCount: 2577, globalCount: 5878, ... }
 *
 * Liquid ne peut pas appeler cette URL, d'où ce script. Le rendu serveur pose déjà des valeurs de
 * repli, saisies par le marchand : si la requête échoue ou tarde, la barre affiche une note plausible
 * plutôt qu'un trou ou un gabarit entre crochets. On ne fait donc que corriger l'affichage.
 *
 * `ratingMean` est sur 5. Le barème d'affichage est porté par le DOM, la maquette demandant /10 ;
 * les étoiles, elles, restent cinq et c'est leur remplissage qui porte la note.
 */

(() => {
  const container = document.querySelector('[data-skeepers-rating]');

  if (!container) {
    return;
  }

  const instanceId = container.dataset.skeepersRating;

  if (!instanceId) {
    return;
  }

  const scale = Number(container.dataset.skeepersRatingScale) || 10;

  fetch(`https://cl-pbr.cxr.skeepers.io/${encodeURIComponent(instanceId)}/stats.json`)
    .then((response) => (response.ok ? response.json() : null))
    .then((stats) => {
      if (!stats) {
        return;
      }

      const valueTarget = container.querySelector('[data-skeepers-rating-value]');

      if (valueTarget && typeof stats.ratingMean === 'number') {
        /* Une décimale, et la virgule attendue en français : `toLocaleString` suit la langue de la
           page plutôt que celle du navigateur, qui peut différer de celle du site. */
        valueTarget.textContent = ((stats.ratingMean * scale) / 5).toLocaleString(
          document.documentElement.lang || 'fr',
          { minimumFractionDigits: 1, maximumFractionDigits: 1 }
        );
      }

      /* Les étoiles suivent la note, pas le barème d'affichage : `ratingMean` est déjà sur 5. */
      if (container.querySelector('[data-skeepers-rating-stars]') && typeof stats.ratingMean === 'number') {
        const fill = Math.max(0, Math.min(100, (stats.ratingMean / 5) * 100));

        container.style.setProperty('--trust-bar-stars-fill', `${fill.toFixed(1)}%`);
      }

      const countTarget = container.querySelector('[data-skeepers-rating-count]');
      const count = stats.currentCount ?? stats.globalCount;

      if (countTarget && typeof count === 'number') {
        countTarget.textContent = count.toLocaleString(document.documentElement.lang || 'fr');
      }
    })
    .catch(() => {
      /* Les valeurs de repli restent en place : rien à faire. */
    });
})();
